'use client'

import { SeparatorBase } from './styles'

export interface SeparatorProps {
  /**
   * Separator variant
   */
  variant?: 'default' | 'primary'

  /**
   * The orientation of the separator
   */
  orientation?: 'horizontal' | 'vertical'

  /**
   * The orientation of the separator on tablet
   */
  tabletOrientation?: 'horizontal' | 'vertical'

  /**
   * The orientation of the separator on desktop
   */
  pcOrientation?: 'horizontal' | 'vertical'

  /**
   * If true, the separator will be hidden from screen readers and search engines
   */
  decorative?: boolean
}

export const Separator = ({
  variant = 'default',
  orientation = 'horizontal',
  decorative,
  ...rest
}: SeparatorProps) => {
  return (
    <SeparatorBase
      role={decorative ? 'none' : 'separator'}
      variant={variant}
      orientation={orientation}
      {...rest}
    />
  )
}
